import { render, staticRenderFns } from "./count-number.vue?vue&type=template&id=94b09e70&scoped=true&"
import script from "./count-number.vue?vue&type=script&lang=js&"
export * from "./count-number.vue?vue&type=script&lang=js&"
import style0 from "./count-number.vue?vue&type=style&index=0&id=94b09e70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b09e70",
  null
  
)

export default component.exports